/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Subtitle_Import_Failed_ToastInputs */

const en_subtitle_import_failed_toast = /** @type {(inputs: Subtitle_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importing subtitle events failed: ${i?.error}`)
};

const fr_subtitle_import_failed_toast = /** @type {(inputs: Subtitle_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de l'importation des evenements de sous-titres : ${i?.error}`)
};

const de_subtitle_import_failed_toast = /** @type {(inputs: Subtitle_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importieren von Untertitelereignissen fehlgeschlagen: ${i?.error}`)
};

const it_subtitle_import_failed_toast = /** @type {(inputs: Subtitle_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importazione degli eventi dei sottotitoli non riuscita: ${i?.error}`)
};

const ru_subtitle_import_failed_toast = /** @type {(inputs: Subtitle_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось импортировать события субтитров: ${i?.error}`)
};

const es_subtitle_import_failed_toast = /** @type {(inputs: Subtitle_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al importar eventos de subtítulos: ${i?.error}`)
};

const zh_cn2_subtitle_import_failed_toast = /** @type {(inputs: Subtitle_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`导入字幕事件失败：${i?.error}`)
};

const ja_subtitle_import_failed_toast = /** @type {(inputs: Subtitle_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`字幕イベントのインポートに失敗しました: ${i?.error}`)
};

const hi_subtitle_import_failed_toast = /** @type {(inputs: Subtitle_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`उपशीर्षक इवेंट आयात करने में विफलता: ${i?.error}`)
};

const pt_pt2_subtitle_import_failed_toast = /** @type {(inputs: Subtitle_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A importação de eventos de legenda falhou: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Importing subtitle events failed: {error}" |
*
* @param {Subtitle_Import_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_failed_toast = /** @type {((inputs: Subtitle_Import_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_import_failed_toast(inputs)
	if (locale === "de") return de_subtitle_import_failed_toast(inputs)
	if (locale === "it") return it_subtitle_import_failed_toast(inputs)
	if (locale === "ru") return ru_subtitle_import_failed_toast(inputs)
	if (locale === "es") return es_subtitle_import_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_import_failed_toast(inputs)
	if (locale === "ja") return ja_subtitle_import_failed_toast(inputs)
	if (locale === "hi") return hi_subtitle_import_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_import_failed_toast(inputs)
	return en_subtitle_import_failed_toast(inputs)
});